import { ObservabilityRuntime } from './types';

function runtimeValue(value: string | undefined, fallback: string): string {
  const normalized = value?.trim();
  return normalized || fallback;
}

export const OBSERVABILITY_RUNTIME: ObservabilityRuntime = Object.freeze({
  environment: runtimeValue(AQT_ENV, import.meta.env.MODE || 'local'),
  service: 'pt-web',
  version: runtimeValue(import.meta.env.VITE_APP_VERSION, 'local'),
});
